import { render, staticRenderFns } from "./TrashVulnerabilitiesPage.vue?vue&type=template&id=52983d5d"
import script from "./TrashVulnerabilitiesPage.vue?vue&type=script&lang=js"
export * from "./TrashVulnerabilitiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports